import { ParentProps } from "solid-js";

export default function Identity(props: ParentProps) {
  return <>{props.children}</>;
}
